// Vue
import { Prop, Vue } from "vue-property-decorator";

import { getTranslatedImage as getTranslatedImageHelper } from "./ModuleHelpers";
import { getTranslatedImageSize as getTranslatedImageSizeHelper } from "./ModuleHelpers";
import { getTranslatedImageType as getTranslatedImageTypeHelper } from "./ModuleHelpers";

export default abstract class ModuleBase extends Vue {
  @Prop({ default: () => ({}) })
  public instance!: object;

  @Prop()
  public id!: number;

  @Prop({ default: "de" })
  public lang!: string;

  @Prop({ default: "GLOBAL" })
  public country!: string;

  @Prop({ default: "auto" })
  public forceBackground!: string;

  get isBackgroundForcedBlack() {
    return this.forceBackground === "black";
  }

  get isBackgroundForcedWhite() {
    return this.forceBackground === "white";
  }

  get backgroundColor() {
    if (this.isBackgroundForcedBlack) {
      return "black";
    } else if (this.isBackgroundForcedWhite) {
      return "white";
    } else {
      return this.getBackgroundColorFromInstance(this.instance);
    }
  }

  abstract getBackgroundColorFromInstance(instance: object): string;

  getTranslatedImage(imageObject, language, size) {
    return getTranslatedImageHelper(imageObject, language, size);
  }

  getTranslatedImageSize(imageObject, language) {
    return getTranslatedImageSizeHelper(imageObject, language);
  }

  getTranslatedImageType(imageObject, language) {
    return getTranslatedImageTypeHelper(imageObject, language);
  }
}
